import { Col, Form, Row, message } from 'antd';
import { useSelector } from 'react-redux';
import { selectUser } from '../../../../auth/states/userSlice';
import { useLocation, useNavigate } from 'react-router';
import { useEffect, useState } from 'react';
import { toasterNotification } from '../../../../common/utils/ToasterNotification';
import { useGetInvoiceNoQuery } from '../../../Invoice(Visa)/Api/Endpoints/invoiceVisaEndpoints';
import dayjs from 'dayjs';
import {
  IBilling_information,
  InvoiceHajjEndPointType,
  InvoiceHajjType,
  IPilgrims_information,
} from '../../Invoice_Hajj/Types/InvoiceHajjTypes';
import { getAirportByItaCode } from '../../../../common/utils/common.utils';
import postDateFormat from '../../../../common/utils/postDateFormat';
import { useGetAllAirportQuery } from '../../../Configuration/airport/endpoints/airportEndpoints';
import { useWatch } from 'antd/es/form/Form';
import { useCheckCreditLimitMutation } from '../../../Client/Client/api/endpoints/clientEndpoints';
import LoadingIndicator from '../../../../components/common/spinner/LoadingIndicator';
import BreadCrumb from '../../../../components/common/breadCrumb/BreadCrumb';
import NewAddHajjFormTop from '../../Invoice_Hajj/Components/NewAddHajjFormTop';
import NewAddHajjPilgrimsInfo from '../../Invoice_Hajj/Components/NewAddHajjPilgrimsInfo';
import InvoiceBillingInfo from '../../../../components/common/Invoice/billingInfo/InvoiceBillingInfo';
import InvoiceSubTotal from '../../../../components/common/Invoice/InvoiceSubTotal';
import { FormButton } from '../../../../components/common/FormItem/FormItems';
import { useCreatePackageRateMutation } from '../api/endpoints/packageRateEndpoints';
import PackageRateHajiInfo from '../components/PackageRateHajiInfo';
import PackageRateAddPilgrimsInfo from '../components/PackageRateAddPilgrimsInfo';
import InvoiceMoneyReceipt from '../../../../common/Invoice/InvoiceMoneyReceipt';

const AddPackageRate = () => {
  const [form] = Form.useForm();
  const user = useSelector(selectUser);
  const navigate = useNavigate();
  const location = useLocation().pathname;
  const [updateAndPrev, setUpdateAndPrev] = useState<boolean>(false);
  const [
    CreatePackageRate,
    {
      isError: packageRatePostIsError,
      isSuccess: packageRatePostIsSuccess,
      isLoading: postLoading,
      reset,
    },
  ] = useCreatePackageRateMutation();

  const [checkCreditLimit, { isLoading: limiLoading }] = useCheckCreditLimitMutation();

  useEffect(() => {
    let timeoutId: NodeJS.Timeout;
    if (packageRatePostIsSuccess) {
      toasterNotification('success', 'Successfully Added');
      form.resetFields();
      reset();
      timeoutId = setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        // navigate('/invoicehajj');
        invoiceNoRefetch();
      }, 100);
    } else if (packageRatePostIsError) {
      message.error("Some thing went's to wrong");
    }
    return () => {
      clearTimeout(timeoutId);
    };
  }, [packageRatePostIsSuccess, packageRatePostIsError]);

  useEffect(() => {
    form.resetFields();
    form.setFieldsValue({
      invoice_no: invoiceNo?.data,
      invoice_sales_date: dayjs(),
    });
  }, [location]);

  const { data: airport } = useGetAllAirportQuery();
  const selectAirport = airport?.data;
  const fullList: IBilling_information[] = useWatch(['billing_information'], form);
  const invoice_net_total = fullList?.reduce((total: any, item: IBilling_information) => {
    const unitPrice = item?.billing_subtotal ?? 0;
    return total + Number(unitPrice);
  }, 0);

  //CREATE INVOCIE HAJJ AND EDIT
  const onFinish = (values: InvoiceHajjType) => {
    const id = values.invoice_combclient_id?.split('-')[1];
    const formatedData: InvoiceHajjEndPointType = {
      invoice_combclient_id: `client-${id}`,
      invoice_haji_group_id: values.invoice_haji_group_id,
      invoice_sales_man_id: values.invoice_sales_man_id,
      invoice_no: values.invoice_no,
      invoice_vat: values.invoice_vat,
      invoice_sales_date: dayjs(values.invoice_sales_date).format('YYYY-MM-DD'),
      invoice_due_date: dayjs(values.invoice_due_date).format('YYYY-MM-DD'),
      invoice_hajj_routes: getAirportByItaCode(
        values?.invoice_hajj_routes as string,
        selectAirport
      ) as number[],
      invoice_agent_id: values?.invoice_agent_id,
      invoice_agent_com_amount: values?.invoice_agent_com_amount,
      hajj_total_pax: values.hajj_total_pax,
      invoice_sub_total: values.invoice_sub_total,
      invoice_discount: values.invoice_discount,
      invoice_service_charge: values.invoice_service_charge,
      invoice_net_total: invoice_net_total,
      invoice_note: values.invoice_note,
      invoice_reference: values.invoice_reference,
      invoice_created_by: user?.user_id as number,
      invoice_hajj_session: dayjs(values.invoice_hajj_session).format('YYYY'),

      pilgrims_information: values?.pilgrims_information
        ?.map((el: IPilgrims_information) => {
          const anyOneExist =
            el.haji_info_passport_id ||
            el.hajiinfo_pid ||
            el.hajiinfo_dob ||
            el.hajiinfo_gender ||
            el.hajiinfo_mobile ||
            el.hajiinfo_name ||
            el.hajiinfo_nid ||
            el.hajiinfo_serial ||
            el.haji_info_haji_id ||
            el.hajiinfo_final_reg_tracking_id;
          if (!anyOneExist) {
            return undefined;
          }
          return {
            ...el,
            hajiinfo_mobile: el.hajiinfo_mobile
              ? el.dialCode + '-' + el.hajiinfo_mobile?.substring(1)
              : undefined,
            hajiinfo_dob: postDateFormat(el.hajiinfo_dob),
            ticket_route: el?.ticket_route?.length
              ? (getAirportByItaCode(el?.ticket_route as string, selectAirport) as string[])
              : undefined,
          };
        })
        .filter((item) => item) as IPilgrims_information[] | [],

      // hotel_information: values?.hotel_information[0]?.hotel_name
      //   ? values.hotel_information?.map((el: IHotel_information) => {
      //       return {
      //         ...el,
      //         hotel_check_in_date: postDateFormat(el.hotel_check_in_date),
      //         hotel_check_out_date: postDateFormat(el.hotel_check_out_date),
      //       };
      //     })
      //   : undefined,
      // transport_info:
      //   JSON.stringify(values?.transport_information[0]) !== "{}"
      //     ? values.transport_information?.map((el: ITransport_information) => {
      //         return {
      //           ...el,
      //           transport_dropoff_place: el.transport_dropoff_place
      //             ? el.transport_dropoff_place
      //             : undefined,
      //           transport_pickup_place: el.transport_pickup_place
      //             ? el.transport_pickup_place
      //             : undefined,
      //           transport_type_id: el.transport_type_id
      //             ? el.transport_type_id
      //             : undefined,
      //           transport_dropoff_time: el.transport_dropoff_time
      //             ? el.transport_dropoff_time
      //             : undefined,
      //           transport_pickup_time: el.transport_pickup_time
      //             ? el.transport_pickup_time
      //             : undefined,
      //         };
      //       })
      //     : undefined,
      billing_information: values.billing_information.map((el: IBilling_information) => {
        delete el?.billing_total_cost_price;
        return {
          ...el,
        };
      }),
      money_receipt: values.receipt_payment_type
        ? {
            receipt_total_amount: values.receipt_total_amount,
            receipt_payment_type: values.receipt_payment_type,
            account_id: values.account_id,
            charge_amount: values.charge_amount,
            cheque_bank_name: values.cheque_bank_name,
            cheque_number: values.cheque_number,
            cheque_withdraw_date: dayjs(values.cheque_withdraw_date).format('YYYY-MM-DD'),
            receipt_money_receipt_no: values.receipt_money_receipt_no,
            receipt_note: values.receipt_note,
            trans_no: values.trans_no,
            receipt_payment_date: dayjs(values.receipt_payment_date).format('YYYY-MM-DD'),
          }
        : undefined,
    };

    checkCreditLimit({
      amount: formatedData.invoice_net_total,
      combClient: formatedData.invoice_combclient_id.toString(),
    }).then((res: any) => {
      if (res?.data?.data === 1) {
        CreatePackageRate({ body: formatedData }).then((res: any) => {
          if (res.data.data.invoice_id)
            updateAndPrev
              ? navigate(`/package-rate/details/${res?.data?.data.invoice_id}`, {
                  state: location,
                })
              : navigate('/package-rate');
        });
      } else {
        message.error(res?.data?.data);
      }
    });
  };

  const onFinishFailed = (values: any) => {
    toasterNotification('error', values.errorFields.length + ' Required fields!');
  };

  const { data: invoiceNo, refetch: invoiceNoRefetch } = useGetInvoiceNoQuery('IH');

  useEffect(() => {
    form.setFieldsValue({
      invoice_no: invoiceNo?.data,
      invoice_sales_date: dayjs(),
    });
  }, [invoiceNo]);

  const clientId = useWatch('invoice_combclient_id', form)?.split('-')[1];

  return (
    <div>
      {postLoading && <LoadingIndicator />}
      <BreadCrumb arrOfOption={['PACKAGE RATE']} />
      {/*  */}
      <Form
        name='basic'
        layout='vertical'
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        form={form}
        initialValues={{
          invoice_hajj_session: dayjs(),
          billing_information: [{ billing_quantity: 1 }],
        }}
      >
        <NewAddHajjFormTop
          form={form}
          invoice_agent_com_amountFieldName={['invoice_agent_com_amount']}
          invoice_net_totalFieldName={['invoice_net_total']}
        />

        <PackageRateAddPilgrimsInfo form={form} clientId={clientId} />
        <InvoiceBillingInfo form={form} setProductId={116} conditionalCostVendor />

        <InvoiceSubTotal form={form} />
        <InvoiceMoneyReceipt form={form} netTotal={Number(invoice_net_total || 0)} />
        {/* @AIR TICKET EDIT BUTTON */}
        <Row justify={'end'} gutter={[10, 10]}>
          <Col>
            <FormButton
              loading={!updateAndPrev && (postLoading || limiLoading)}
              label='CREATE'
              onClick={() => {
                setUpdateAndPrev(false);
              }}
            />
          </Col>
          <Col>
            <FormButton
              loading={updateAndPrev && (postLoading || limiLoading)}
              label='CREATE & PREVIEW'
              onClick={() => {
                setUpdateAndPrev(true);
              }}
            />
          </Col>
        </Row>
      </Form>
      {postLoading && <LoadingIndicator />}
    </div>
  );
};

export default AddPackageRate;
